export default __webpack_public_path__ + "static/media/linkedin.437e9684.svg";